export default {
  tokenKey: '@space-management:token',
  userKey: '@space-management:user',
  memberKey: '@space-management:member',
  refreshTokenKey: '@space-management:refreshToken',
  userIdKey: '@space-management:userId',
  tokenExpirationKey: '@space-management:tokenExpiration',
  languageKey: '@space-management:language',
  loadUserTimestamp: '@space-management:loadUserTimestamp',
  webview: '@space-management:webview',
};
